<template>
  <div class="chart-area">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
  export default {
    props:{
      series: {
        type: Array
      }
    },
    watch:{
      series(){
        this.draw();
      }
    },
    // computed: {
    //   chartData: function(){
    //     return this.chartLowData();
    //   }
    // },
    data(){
      return {
        // idcList: null,
        // chartLowData : [
        //   [18.9, 21],
        //   [20, 23],
        //   [19.9, 24],
        //   [20.9, 22],
        //   [21.9, 23],
        //   [23.9, 26],
        // ],
        chartOptions: {
          colors: ['#14adea', '#2d5cff', '#7d9cff', '#915ffc', '#5b42ea', '#151578',
            '#6cf298', '#00d8b5'
          ],
          chart: {
            type: 'area',
            height: 220,
            style: {
              fontFamily: 'Roboto, sans-serif;'
            }
          },

          accessibility: {
            description : null
          },

          credits: {
            enabled: false
          },

          title: {
            text: null
          },

          subtitle: {
            text: null
          },

          xAxis: {
            categories: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            tickmarkPlacement: 'on',
            //max: 17,
            gridLineWidth: 1,
            minorTickInterval: 1

          },

          yAxis: {
            min: 0,
            title: {
              text: null
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'gray'
              }
            },
            gridLineWidth: 1,
            minorTickInterval: 1000
          },

          tooltip: {
            headerFormat: "<b>{point.x}</b><br/>",
            pointFormat: "{series.name}: {point.y}<br/>",
            borderWidth: 0,
            borderRadius: 0,
            shadow: false
          },

          plotOptions: {
            area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                lineWidth: 1,
                lineColor: '#666666'
              }
            }
          },

          legend: {
            align: 'right',
            x: -100,
            verticalAlign: 'top',
            y: -10,
            floating: true,
            backgroundColor: 'white',
            borderColor: '#CCC',
            borderWidth: 1,
            shadow: false
          },

          series: [
            {
              name: '',
              data: [0,0,0,0,0,0,0,0,0,0,0,0]
            }
            // {
            //   name: '가산',
            //   data: [502, 635, 809, 947, 1402, 3634, 5268]
            // }, {
            //   name: '데이터센터 각',
            //   data: [106, 107, 111, 133, 221, 767, 1766]
            // }, {
            //   name: '대전',
            //   data: [163, 203, 276, 408, 547, 729, 628]
            // }, {
            //   name: '여의도',
            //   data: [18, 31, 54, 156, 339, 818, 1201]
            // }, {
            //   name: '판교',
            //   data: [2, 2, 2, 6, 13, 30, 46]
            // }
          ]
        },
      }
    },
    mounted(){
    },
    methods: {
      draw(){
        this.chartOptions.series = this.series;
      }
    }
  }
</script>

<style>

</style>
